"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemberBadgeList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all badges belonging to a member.
 * Member can be identified by either Discord ID or Steam ID, but at least one of those values **must** be provided.
 *
 * ### Filter options
 *
 * - `gameId` - filters by ID of the Steam game the badge belongs to,
 * - `title` - filters by title of the non-Steam game the badge belongs to,
 * - `isSteamGame` - filters by game being on Steam or not,
 * - `isLegacy` - filters by badge's `legacy` status,
 * - `isEnabled` - filters by badge's `enabled` status.
 *
 * ### Sort options
 *
 * - `points` - sorts by badge's point value.
 *
 * ## Usage
 *
 * ```ts
 * const steamId: string = "567876545678";
 * const badges: Badge[] = await sdk.getMemberBadgeList({ steamId });
 * const badgePointsAsc: Badge[] = await sdk.getMemberBadgeList({ steamId, sort: { points: 'asc' }});
 * const badgesSteamGames: Badge[] = await sdk.getMemberBadgeList({ steamId, filter: { isSteamGame: true }});
 * ```
 *
 * @param params.steamId   - (Optional) Steam ID of the requested member.
 * @param params.discordId - (Optional) Discord ID of the requested member.
 * @param params.filter - Filter to apply to returned badge list.
 * @param params.sort - Fields to sort badge list by.
 * @param params.limit - How many badges will get returned.
 */
const getMemberBadgeList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { steamId, discordId, filter, sort, limit } = params;
    const memberId = steamId !== null && steamId !== void 0 ? steamId : discordId;
    const url = `${BASE_URL}/members/member/${memberId}/badges/list`;
    const memberBadgeListResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = memberBadgeListResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getMemberBadgeList = getMemberBadgeList;
